import Dropdown from 'src/components/layout/navbar/dropdown';
import css from './menu.module.scss';
import SearchInput from 'src/components/form/search-input/search-input';
import { createSearchParams, Link, useNavigate } from 'react-router-dom';
import { GLOBAL_SEARCH } from 'src/constants/routes';

export default function Menu() {
  const navigate = useNavigate();

  function handleSearch(value: string) {
    const trimedValue = value?.trim();
    trimedValue?.length > 0 &&
      navigate({
        pathname: GLOBAL_SEARCH.path,
        search: createSearchParams({
          search: trimedValue
        }).toString()
      });
  }
  return (
    <div className={css.menu}>
      <div className={css.container}>
        <div className={css.searchGroup}>
          <SearchInput
            id='navbar-search'
            name='navbar-search'
            placeholder='Пошук'
            onSearch={(value: string) => handleSearch(value)}
            className={css.mainPageSearch}
            showBtn={true}
          />
        </div>
        <div className={css.activeLinks}>
          Наприклад:
          <Link
            to={{
              pathname: GLOBAL_SEARCH.path,
              search: createSearchParams({
                search: 'Військовослужбовцям'
              }).toString()
            }}>
            Військовослужбовцям,
          </Link>
          <Link
            to={{
              pathname: GLOBAL_SEARCH.path,
              search: createSearchParams({
                search: 'Родинам'
              }).toString()
            }}>
            Родинам
          </Link>
          або
          <Link
            to={{
              pathname: GLOBAL_SEARCH.path,
              search: createSearchParams({
                search: 'Реабілітація'
              }).toString()
            }}>
            Реабілітація
          </Link>
        </div>
      </div>
      <Dropdown />
    </div>
  );
}
